import classNames from 'classnames';
import React from 'react';
import animationStyles from '../../../../animations/grid-animations.module.scss';
import { useConfig } from '../../../../contexts/config-context';
import { getGridStyle } from './grid-options';
import styles from './grid.module.scss';
import responsiveStyles from './responsive-grid.module.scss';
import { useResponsiveGrid } from './use-responsive-grid';
export const Grid = ({ items, layout, isRTL })=>{
    const { isMobile, enableAnimations } = useConfig();
    const responsiveGrid = useResponsiveGrid();
    const responsive = Boolean(responsiveGrid);
    const reactElementsByRow = getReactElementsByRow(items);
    return /*#__PURE__*/ React.createElement("div", {
        className: classNames(styles.container, {
            [styles.responsive]: responsive
        }),
        style: {
            '--form-columns': layout.columns
        },
        dir: isRTL ? 'rtl' : ''
    }, reactElementsByRow.map((rowData, index)=>{
        const fieldId = rowData.firstFieldId;
        const key = isMobile && fieldId || index;
        return(// The fragment keeps the row's remount key; each field scrolls
        // itself into view when focused (see DefaultFieldLayout).
        /*#__PURE__*/ React.createElement(React.Fragment, {
            key: fieldId
        }, /*#__PURE__*/ React.createElement("div", {
            key: key,
            style: getGridStyle({
                responsive
            }),
            className: classNames(styles.grid, styles.column, {
                // With cssMobileLayout, this row is display: contents below
                // the mobile breakpoint, so the animation doesn't play there.
                [animationStyles.animations]: enableAnimations,
                [responsiveStyles.grid]: responsive
            })
        }, rowData.elements)));
    }));
};
function getReactElementsByRow(items) {
    const reactElementsByRow = items.reduce((result, item)=>{
        const row = item.layout.row;
        const element = /*#__PURE__*/ React.cloneElement(item.component, {
            key: item.id
        });
        if (result[row]) {
            result[row].elements.push(element);
        } else {
            result[row] = {
                elements: [
                    element
                ],
                firstFieldId: item.id
            };
        }
        return result;
    }, []);
    return reactElementsByRow;
}

//# sourceMappingURL=grid.js.map